export enum SwipeQuestionCardSide {
    LEFT,
    RIGHT,
  }
  